var map = {
	"./St 4-EMU-correct.wav": "34bc",
	"./St 4-EMU-hint.wav": "ed3c",
	"./St 4-EMU-incorrect.wav": "68c5",
	"./St 4-EMU-question.wav": "4e0b",
	"./St 4-End Screen.wav": "8169",
	"./St 4-Question 13-correct.wav": "1a41",
	"./St 4-Question 13-hint.wav": "0ac8",
	"./St 4-Question 13-incorrect.wav": "1763",
	"./St 4-Question 13-question.wav": "3f19",
	"./St 4-Question 15-correct.wav": "5b61",
	"./St 4-Question 15-hint.wav": "b515",
	"./St 4-Question 15-incorrect.wav": "a733",
	"./St 4-Question 15-question.wav": "574e",
	"./St 4-Screen 2.wav": "a3e9",
	"./St 4-Screen 3.wav": "a021",
	"./St 4-Screen 4.wav": "011e",
	"./St 4-charging station-correct.wav": "8d88",
	"./St 4-charging station-hint.wav": "5d2e",
	"./St 4-charging station-incorrect.wav": "7ae9",
	"./St 4-charging station-question.wav": "b5e8",
	"./St 4-computer-correct.wav": "f7d9",
	"./St 4-computer-hint.wav": "aa64",
	"./St 4-computer-incorrect.wav": "68d8",
	"./St 4-computer-question.wav": "1c2f",
	"./St 4-desk lamp-correct.wav": "7330",
	"./St 4-desk lamp-hint.wav": "a8c7",
	"./St 4-desk lamp-incorrect.wav": "5db5",
	"./St 4-desk lamp-question.wav": "5b4c",
	"./St 4-dishwasher-correct.wav": "77ae",
	"./St 4-dishwasher-hint.wav": "9750",
	"./St 4-dishwasher-incorrect.wav": "856c",
	"./St 4-dishwasher-question.wav": "b295",
	"./St 4-game console-correct.wav": "cb1c",
	"./St 4-game console-hint.wav": "8dbb",
	"./St 4-game console-incorrect.wav": "3a71",
	"./St 4-game console-question.wav": "ed8d",
	"./St 4-keyboard-correct.wav": "a4a7",
	"./St 4-keyboard-hint.wav": "8858",
	"./St 4-keyboard-incorrect.wav": "e896",
	"./St 4-keyboard-question.wav": "d8b9",
	"./St 4-light switch-correct.wav": "c2d7",
	"./St 4-light switch-hint.wav": "4b81",
	"./St 4-light switch-incorrect.wav": "68ce",
	"./St 4-light switch-question.wav": "602a",
	"./St 4-phone-tablet-correct.wav": "a9d4",
	"./St 4-phone-tablet-hint.wav": "7907",
	"./St 4-phone-tablet-incorrect.wav": "9903",
	"./St 4-phone-tablet-question.wav": "043d",
	"./St 4-refrigerator-correct.wav": "9a54",
	"./St 4-refrigerator-hint.wav": "4fe5",
	"./St 4-refrigerator-incorrect.wav": "b483",
	"./St 4-refrigerator-question.wav": "c6f8",
	"./St 4-thermostat-correct.wav": "41da",
	"./St 4-thermostat-hint.wav": "9a80",
	"./St 4-thermostat-incorrect.wav": "f818",
	"./St 4-thermostat-question.wav": "3f72",
	"./St 4-thermostat2-correct.wav": "c1b8",
	"./St 4-thermostat2-hint.wav": "c5a5",
	"./St 4-thermostat2-incorrect.wav": "8d66",
	"./St 4-thermostat2-question.wav": "a839",
	"./St 4-washer dryer-correct.wav": "5c66",
	"./St 4-washer dryer-hint.wav": "1ab2",
	"./St 4-washer dryer-incorrect.wav": "b7e9",
	"./St 4-washer dryer-question.wav": "6aee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72f6";